// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
// 引入element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/zh-CN'

import App from './App';
// 引入路由
import router from './router';
// 引入状态管理
import store from './vuex/store';
// 引入icon
import './assets/icon/iconfont.css'

// 引入权限指令
import permission from './directives/permission'
// 注册权限指令
Vue.directive('permission', permission)

// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import axios from 'axios';
Vue.prototype.$axios = axios;

// 引入字典插件
import DictPlugin from './utils/dictPlugin'
Vue.use(DictPlugin)

Vue.config.productionTip = false;

// 使用element UI
Vue.use(ElementUI, {locale});
// 过滤器
import * as custom from './utils/util'

Object.keys(custom).forEach(key => {
    Vue.filter(key, custom[key])
})

// 初始化Stagewise工具栏 - 仅在开发模式下
if (process.env.NODE_ENV === 'development') {
  require('./utils/stagewise');
}

// 路由拦截器
router.beforeEach((to, from, next) => {
    if (to.matched.length != 0) {
        if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
            if (Boolean(localStorage.getItem("userInfo"))) { // 通过vuex state获取当前的user是否存在
                next();
            } else {
                next({
                    path: '/login',
                    query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
                })
            }
        } else {
            if (Boolean(localStorage.getItem("userInfo"))) { // 判断是否登录
                if (to.path != "/" && to.path != "/login") { //判断是否要跳到登录界面
                    next();
                } else {
                    // 登录后的首页
                    next({
                        path: '/DashBoard'
                    })
                }
            } else {
                next();
            }
        }
    } else {
        next({
            query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
        })
    }
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store, //使用store vuex状态管理
    components: { App },
    template: '<App/>',
    data: {
        // 空的实例放到根组件下，所有的子组件都能调用
        Bus: new Vue()
    },
    beforeCreate() {
        // 将router和store挂载到window对象上，便于axios拦截器使用
        window.$router = this.$router;
        window.$store = this.$store;
    },
    created() {
        // 如果用户已登录但权限列表为空，自动获取权限
        if (localStorage.getItem("userInfo") && this.$store.getters.permissions.length === 0) {
            console.log("检测到用户已登录但权限列表为空，自动获取权限");
            this.$store.dispatch('getPermissions').catch(err => {
                console.error("自动获取权限失败", err);
            });
        }
    }
})



// WEBPACK FOOTER //
// ./src/main.js